function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("rect", {
  x: 0.5,
  width: 28,
  height: 28,
  rx: 4,
  fill: "#252CA0"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M20.75 4H8.25C7.55964 4 7 4.55964 7 5.25V22.75C7 23.4404 7.55964 24 8.25 24H20.75C21.4404 24 22 23.4404 22 22.75V5.25C22 4.55964 21.4404 4 20.75 4Z",
  fill: "#D9EFFE"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M10.7402 8.6209L9.40234 7.11273L10.279 6.33508L10.8485 6.97703L12.1213 5.875L12.8883 6.76094L10.7402 8.6209Z",
  fill: "#238619"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  d: "M18.2207 7.06274H14.5586C14.235 7.06274 13.9727 7.32508 13.9727 7.64868C13.9727 7.97229 14.235 8.23462 14.5586 8.23462H18.2207C18.5443 8.23462 18.8066 7.97229 18.8066 7.64868C18.8066 7.32508 18.5443 7.06274 18.2207 7.06274Z",
  fill: "#5C3CD6"
});

var _ref6 =
/*#__PURE__*/
React.createElement("path", {
  d: "M10.7402 13.6209L9.40234 12.1127L10.279 11.3351L10.8485 11.977L12.1213 10.875L12.8883 11.7609L10.7402 13.6209Z",
  fill: "#238619"
});

var _ref7 =
/*#__PURE__*/
React.createElement("path", {
  d: "M18.2207 12.0625H14.5586C14.235 12.0625 13.9727 12.3248 13.9727 12.6484C13.9727 12.972 14.235 13.2344 14.5586 13.2344H18.2207C18.5443 13.2344 18.8066 12.972 18.8066 12.6484C18.8066 12.3248 18.5443 12.0625 18.2207 12.0625Z",
  fill: "#5C3CD6"
});

var _ref8 =
/*#__PURE__*/
React.createElement("path", {
  d: "M18.2207 15.8752H14.5586C14.235 15.8752 13.9727 16.1376 13.9727 16.4612C13.9727 16.7848 14.235 17.0471 14.5586 17.0471H18.2207C18.5443 17.0471 18.8066 16.7848 18.8066 16.4612C18.8066 16.1376 18.5443 15.8752 18.2207 15.8752Z",
  fill: "#5C3CD6"
});

var _ref9 =
/*#__PURE__*/
React.createElement("path", {
  d: "M18.2207 19.625H14.5586C14.235 19.625 13.9727 19.8873 13.9727 20.2109C13.9727 20.5345 14.235 20.7969 14.5586 20.7969H18.2207C18.5443 20.7969 18.8066 20.5345 18.8066 20.2109C18.8066 19.8873 18.5443 19.625 18.2207 19.625Z",
  fill: "#5C3CD6"
});

var _ref10 =
/*#__PURE__*/
React.createElement("path", {
  d: "M11.5931 19.625H10.4141V20.7969H11.5931V19.625Z",
  fill: "#EA4AC7"
});

var _ref11 =
/*#__PURE__*/
React.createElement("path", {
  d: "M11.5931 15.875H10.4141V17.0469H11.5931V15.875Z",
  fill: "#EA4AC7"
});

var SvgBrokerOrderBookActive = function SvgBrokerOrderBookActive(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 29,
    height: 28,
    viewBox: "0 0 29 28",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgBrokerOrderBookActive, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/broker_order_book_active.fc502f4c.svg";
export { ForwardRef as ReactComponent };